import React, { useState } from "react";
import { TextInput, Badge } from "@mantine/core";
import { IconBarcode } from "@tabler/icons-react";
import { useBarcodeScan } from "../../hooks/useBarcodeScan";

interface Props {
  onScan: (value: string) => void;
  deviceId?: string;
  placeholder?: string;
  label?: string;
}

const BarcodeScanInput: React.FC<Props> = ({
  onScan,
  deviceId,
  placeholder = "Scan barcode...",
  label,
}) => {
  const [lastScanned, setLastScanned] = useState<string | null>(null);

  useBarcodeScan({
    onScan: (value) => {
      setLastScanned(value);
      onScan(value);
    },
    deviceId,
  });

  return (
    <div>
      <TextInput
        label={label}
        placeholder={placeholder}
        leftSection={<IconBarcode size={16} />}
        value={lastScanned || ""}
        onChange={(e) => {
          setLastScanned(e.currentTarget.value);
          if (e.currentTarget.value) onScan(e.currentTarget.value);
        }}
        rightSection={
          lastScanned ? (
            <Badge size="xs" color="green">
              Scanned
            </Badge>
          ) : null
        }
      />
    </div>
  );
};

export default BarcodeScanInput;
